/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Fetching_Selected_Carrier_RatesInputs */

const en_orders_fetching_selected_carrier_rates = /** @type {(inputs: Orders_Fetching_Selected_Carrier_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching rates for the selected carrier...`)
};

const es_orders_fetching_selected_carrier_rates = /** @type {(inputs: Orders_Fetching_Selected_Carrier_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo tarifas para el transportista seleccionado...`)
};

/**
* | output |
* | --- |
* | "Fetching rates for the selected carrier..." |
*
* @param {Orders_Fetching_Selected_Carrier_RatesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_fetching_selected_carrier_rates = /** @type {((inputs?: Orders_Fetching_Selected_Carrier_RatesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Fetching_Selected_Carrier_RatesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_fetching_selected_carrier_rates(inputs)
	return es_orders_fetching_selected_carrier_rates(inputs)
});